import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

const SITUATIONS = [
  {
    title: "A bid, a result or a board paper may have reached someone",
    desc: "We examine the rooms where it was discussed, before they are used again.",
  },
  {
    title: "A board, audit committee or investor meeting is coming",
    desc: "We attend before the meeting and examine the room, method by method.",
  },
  {
    title: "A hotel or venue you don't control",
    desc: "We inspect spaces you do not control before your people use them.",
  },
  {
    title: "A new office, renovation or unknown wire",
    desc: "We verify new or altered spaces before anything sensitive is said in them.",
  },
];

// Second screen on the homepage: situation picker + speed/cost/privacy strip.
export default function Situations() {
  return (
    <section className="border-t border-hairline py-12 sm:py-16" data-testid="situations-section">
      <div className="site-x">
        <Reveal>
          <h2 className="font-head font-extrabold tracking-tight h-sec">
            Do any of these sound like you?
          </h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SITUATIONS.map(({ title, desc }, i) => (
            <Reveal key={title} delay={i * 0.06} className="h-full">
              <button
                onClick={() => scrollToId("contact")}
                data-testid={`situation-card-${i + 1}`}
                className="group flex h-full w-full flex-col justify-between gap-6 border border-hairline bg-surface p-6 text-left transition-colors hover:border-violet"
              >
                <span>
                  <span className="block text-base font-semibold leading-snug">{title}</span>
                  <span className="mt-2.5 block text-sm leading-relaxed text-sub">{desc}</span>
                </span>
                <span className="inline-flex items-center gap-1.5 text-[0.625rem] uppercase tracking-[0.16em] text-sub transition-colors group-hover:text-violet">
                  Talk to us
                  <ArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
